import { StoreState } from "./index";
import get from "lodash/get";

import * as fromAnimation from "./animation/methods";
import * as fromConfig from "./config/methods";
import * as FromData from "./data/methods";
import * as fromExchange from "./exchange/methods";
import * as fromLoyalty from "./loyalty/methods";
import * as fromMemberTier from "./memberTier/methods";
import * as fromMerchant from "./merchant/methods";
import * as fromReferral from "./referral/methods";
import * as fromRequestStatus from "./requestStatus/methods";
import * as fromReward from "./reward/methods";
import * as fromShare from "./share/methods";
import * as fromWidget from "./widget/methods";

export const isRehydrated = (state: StoreState) => state._persist.rehydrated;

export const getRootURL = (state: StoreState) =>
  fromConfig.getRootURL(state.config);

export const getMerchantId = (state: StoreState) =>
  fromMerchant.getMerchantId(state.merchant);

export const getCampaignId = (state: StoreState) =>
  fromMerchant.getCampaignId(state.merchant);

export const getScreenName = (state: StoreState) =>
  fromWidget.getScreenName(state.widget);

export const getIsOverlay = (state: StoreState) =>
  fromWidget.getIsOverlay(state.widget);

export const getDisplaySize = (state: StoreState) =>
  fromWidget.getDisplaySize(state.widget);

export const getWidgetFormErrors = (state: StoreState) =>
  fromWidget.getWidgetFormErrors(state.widget);

export const getWidgetFormError = (state: StoreState, path: string): string => {
  const errors = getWidgetFormErrors(state);

  return get(errors, path) as any as string;
};

export const getWidgetId = (state: StoreState) =>
  fromWidget.getWidgetId(state.widget);

export const getWidgetConfigId = (state: StoreState) =>
  fromWidget.getWidgetConfigId(state.widget);

export const getWidgetConfig = (state: StoreState) =>
  fromWidget.getWidgetConfig(state.widget);

// export const getReferralLink = (state: StoreState) =>
//   fromReferral.getReferralLink(state.referral);

export const getReferralResponse = (state: StoreState) =>
  fromReferral.getReferralResponse(state.referral);

export const getShareResponse = (state: StoreState) =>
  fromShare.getShareResponse(state.share);

export const getReferralRequestStatus = (state: StoreState) =>
  fromRequestStatus.getReferralRequestStatus(state.requestStatus);

export const getShareRequestStatus = (state: StoreState) =>
  fromRequestStatus.getShareRequestStatus(state.requestStatus);

// Animation's methods
export const getAnimationStartTime = (state: StoreState) =>
  fromAnimation.getAnimationStartTime(state.animation);

export const getAnimationStatus = (state: StoreState) =>
  fromAnimation.getAnimationStatus(state.animation);

export const getExitTimeout = (state: StoreState) =>
  fromAnimation.getExitTimeout(state.animation);

export const getEnterTimeout = (state: StoreState) =>
  fromAnimation.getEnterTimeout(state.animation);

export const getEnterOffset = (state: StoreState, index: number) =>
  fromAnimation.getEnterOffset(state.animation, index);

export const getExitOffset = (state: StoreState, index: number) =>
  fromAnimation.getExitOffset(state.animation, index);

export const getWidgetData = (state: StoreState) =>
  FromData.getWidgetData(state.data);

// Reward methods
export const getAccountCreditRedeem = (state: StoreState) =>
  fromReward.getAccountCreditRedeem(state.reward);

export const getCoupon = (state: StoreState) =>
  fromReward.getCoupon(state.reward);

export const getLedgerHead = (state: StoreState) =>
  fromReward.getLedgerHead(state.reward);

export const getRewardStats = (state: StoreState) =>
  fromReward.getRewardStats(state.reward);

export const getRewardRequestStatus = (state: StoreState) =>
  fromReward.getRequestStatus(state.reward);

export const getShopifyActiveDiscounts = (state: StoreState) =>
  fromReward.getShopifyActiveDiscounts(state.reward);

export const getShopifyActiveGiftCards = (state: StoreState) =>
  fromReward.getShopifyActiveGiftCards(state.reward);

// Exchanges
export const getExchanges = (state: StoreState) =>
  fromExchange.getExchanges(state.exchange);

export const getExchangeId = (state: StoreState) =>
  fromExchange.getExchangeId(state.exchange);

// Loyalty
export const getTransactionId = (state: StoreState) =>
  fromLoyalty.getTransactionId(state.loyalty);

// Member Tier
export const getMemberTierCustomer = (state: StoreState) =>
  fromMemberTier.getMemberTierCustomer(state.memberTier);

export const getIsMemberTierLoading = (state: StoreState) =>
  fromMemberTier.getIsLoading(state.memberTier);

// Referral
export const getReferral = (state: StoreState) =>
  fromReferral.getReferralResponse(state.referral);

export const getQR = (state: StoreState) => fromReferral.getQR(state.referral);

export const getIsLoadingReferral = (state: StoreState) =>
  fromReferral.getIsLoadingReferral(state.referral);

export const getIsLoadingQR = (state: StoreState) =>
  fromReferral.getIsLoadingQR(state.referral);

export const getQRError = (state: StoreState) =>
  fromReferral.getQRError(state.referral);

export const getGoogleWalletResponse = (state: StoreState) =>
  fromReferral.getGoogleWalletResponse(state.referral);

export const getAppleWalletResponse = (state: StoreState) =>
  fromReferral.getAppleWalletResponse(state.referral);

export const getIsLoadingAppleWallet = (state: StoreState) =>
  fromReferral.getIsLoadingAppleWallet(state.referral);

export const getAppleWalletError = (state: StoreState) =>
  fromReferral.getAppleWalletError(state.referral);
